import { render, staticRenderFns } from "./MItem.vue?vue&type=template&id=65bfaf55&scoped=true&"
import script from "./MItem.vue?vue&type=script&lang=js&"
export * from "./MItem.vue?vue&type=script&lang=js&"
import style0 from "./MItem.vue?vue&type=style&index=0&id=65bfaf55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bfaf55",
  null
  
)

export default component.exports